import React from 'react';

import './style.css';
import '../../../grid.css';


const FinancingLegal = () => (
    <div className="row">
        <h1 className="section">NYSERDA</h1>
        <p>While Solvana cannot guarantee NY State PV solar-generating system Incentive eligibility or the final value of the Incentive, we strive very hard to provide you with the most up-to-date information available. For more details on NY State PV solar-generating system Incentives and how they can benefit you, please visit https://www.nyserda.ny.gov/All-Programs/Programs/NY-Sun.
        </p>
    </div>
);

export default FinancingLegal;



// WEBPACK FOOTER //
// ./src/containers/Legal/NYLegal/index.js